// src/components/visitors/ConvertVisitorModal.js
import React, { useState } from 'react';
import axios from 'axios';
import { X, Check } from 'lucide-react';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8001';

const ConvertVisitorModal = ({ isOpen, selectedVisitor, owners, onClose, onSuccess }) => {
  const [selectedOwnerId, setSelectedOwnerId] = useState('');
  const [converting, setConverting] = useState(false);

  if (!isOpen || !selectedVisitor) return null;

  const countMovements = (movements, type) => {
    if (!movements) return 0;
    return movements.filter(m => m.type === type).length;
  };

  const handleConvert = async () => {
    if (!selectedVisitor || !selectedOwnerId) return;
    setConverting(true);
    try {
      await axios.post(`${API_BASE}/tracking/visits/${selectedVisitor.id}/convert`, null, {
        params: { owner_id: selectedOwnerId }
      });
      onSuccess();
      onClose();
    } catch (err) {
      console.error('Error converting visitor:', err);
      alert('Error during conversion');
    } finally {
      setConverting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-xl w-full max-w-md">
        <div className="p-4 border-b border-gray-700 flex justify-between items-center">
          <h3 className="text-white font-semibold">Convert to Registered Aircraft</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-white">
            <X size={20} />
          </button>
        </div>
        <div className="p-4 space-y-4">
          <p className="text-gray-300">
            Convert <span className="font-mono text-white">{selectedVisitor.tail_number}</span> to a registered aircraft?
          </p>
          <div>
            <label className="text-gray-400 text-sm block mb-1">Select Owner</label>
            <select
              value={selectedOwnerId}
              onChange={(e) => setSelectedOwnerId(e.target.value)}
              className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-white"
            >
              <option value="">-- Select owner --</option>
              {owners.map(owner => (
                <option key={owner.id} value={owner.id}>
                  {owner.company_name || `${owner.first_name || ''} ${owner.last_name || ''}`.trim() || owner.email}
                </option>
              ))}
            </select>
          </div>
          <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-3">
            <p className="text-yellow-400 text-xs">
              ⚠️ All past movements ({countMovements(selectedVisitor.movements, 'TAKEOFF')} takeoffs,{' '}
              {countMovements(selectedVisitor.movements, 'LANDING')} landings) will become billable.
            </p>
          </div>
        </div>
        <div className="p-4 border-t border-gray-700 flex justify-end gap-3">
          <button onClick={onClose}
            className="px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg text-white text-sm">
            Cancel
          </button>
          <button onClick={handleConvert}
            disabled={!selectedOwnerId || converting}
            className="px-4 py-2 bg-green-600 hover:bg-green-700 disabled:opacity-50 rounded-lg text-white text-sm flex items-center gap-2">
            {converting
              ? <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
              : <Check size={16} />}
            Convert
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConvertVisitorModal;